import React, { createContext, ReactNode, useEffect, useState } from 'react'
import type { Analytics, EventParams } from 'firebase/analytics'
import { getAnalytics, logEvent as logEventFn } from 'firebase/analytics'

import { app as firebaseApp } from 'src/configuration-firebase'

import { AnalyticsContextValue } from 'src/contexts/AnalyticsContext/types'

export const AnalyticsContext = createContext<AnalyticsContextValue>({
  instance: null,
  logEvent: () => {},
})

export const AnalyticsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [instance, setInstance] = useState<Analytics | null>(null)

  useEffect(() => {
    const analyticsInstance = getAnalytics(firebaseApp)
    setInstance(analyticsInstance)
  }, [])

  const logEvent = (name: string, params?: EventParams) => {
    if (instance) {
      logEventFn(instance, name, params)
    }
  }

  return (
    <AnalyticsContext.Provider value={{ instance, logEvent }}>
      {children}
    </AnalyticsContext.Provider>
  )
}
